import { useSeoMeta } from '@unhead/react';
import { VideoFeed } from '@/components/VideoFeed';
import { Button } from '@/components/ui/button';
import { PlusCircle } from 'lucide-react';
import { useState } from 'react';
import { AddBookmarkDialog } from '@/components/AddBookmarkDialog';
import { LoginArea } from '@/components/LoginArea';

const Index = () => {
  useSeoMeta({
    title: 'NostrVidster - Video Bookmarking on Nostr',
    description: 'Discover, bookmark, and share videos on the Nostr network.',
  });

  const [showAddDialog, setShowAddDialog] = useState(false);

  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* Neon border accent */}
      <div className="fixed top-0 left-0 w-1 h-full bg-gradient-to-b from-pink-500 via-cyan-400 to-transparent opacity-50" />
      
      <header className="border-b border-border bg-card/50 backdrop-blur-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <h1 className="text-2xl font-bold">
              <span className="text-pink-500 drop-shadow-[0_0_8px_rgba(236,72,153,0.5)]">
                NostrVidster
              </span>
            </h1>
          </div>
          
          <div className="flex items-center space-x-4">
            <LoginArea />
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8">
        {/* Floating action button for adding bookmarks */}
        <div className="fixed bottom-8 right-8 z-40">
          <Button
            size="lg"
            className="rounded-full shadow-lg shadow-pink-500/20 bg-pink-500 hover:bg-pink-600 text-white"
            onClick={() => setShowAddDialog(true)}
          >
            <PlusCircle className="h-5 w-5 mr-2" />
            Add Bookmark
          </Button>
        </div>

        <VideoFeed />
      </main>

      <AddBookmarkDialog open={showAddDialog} onOpenChange={setShowAddDialog} />
    </div>
  );
};

export default Index;